/**
 * 并行执行任务
 * @param {Array<() => Promise<T>>} tasks - 待执行任务数组
 * @param {number} [size=10] - 并发数量
 * @returns {Promise<Array<{data: T, error?: Error}>>} - 返回一个包含每个任务结果的数组
 */
export const asyncBatch = async (tasks, size = 10) => {
  if (!Array.isArray(tasks) || tasks.length === 0) {
    return [];
  }

  const executing = [];
  const results = new Array(tasks.length);
  for (const [idx, task] of Object.entries(tasks)) {
    const ps = Promise.resolve()
      .then(() => task())
      .then((data) => {
        results[idx] = { data };
      })
      .catch((error) => {
        results[idx] = { error };
      })
      .finally(() => {
        executing.splice(executing.indexOf(ps), 1);
      });

    executing.push(ps);
    if (executing.length >= size) await Promise.race(executing);
  }
  await Promise.all(executing);
  return results;
};
